import { FBQ, GTM } from '@wegic/analytics';
import { saveSource } from '@wegic/common';
import { isOnline } from '@/const/env';
import { saveAnonymousCashierAttributionIfDetected } from '@/helpers/pay/anonymousCashierAttribution';
import { setTargetLayer } from '@/helpers/preview/helper';
import { initABTest } from '@/modules/ABTest/helper';
import { initCollectSDK } from '@/modules/Collect';
import { initMemoryMonitor } from '@/modules/MemoryMonitor';
import { installPerformanceDebugReport } from '@/modules/PerformanceDebug';
import { loadPerformanceMonitor } from '@/modules/PerformanceMonitor';
import { initRuntimeDiagnostics } from '@/modules/RuntimeDiagnostics';

class AppLifecycle {
  private beforeAppRenderInitialized = false;
  private afterAppMountInitialized = false;

  beforeAppRender() {
    if (this.beforeAppRenderInitialized) {
      return;
    }

    this.beforeAppRenderInitialized = true;
    saveSource();
    saveAnonymousCashierAttributionIfDetected();
    initCollectSDK(null, isOnline);
  }

  afterAppMount() {
    if (this.afterAppMountInitialized) {
      return;
    }

    this.afterAppMountInitialized = true;
    if (!isOnline) {
      installPerformanceDebugReport();
      // 调试工具：手动切换预览层
      window.__setPreviewDebugLayer = (layer: 'live' | 'stable') => {
        setTargetLayer(layer);
        // eslint-disable-next-line no-console
        console.log(`[Debug] switched to ${layer}`);
      };
      // eslint-disable-next-line no-console
      console.info('[Debug] injected: window.__setPreviewDebugLayer("live" | "stable")');
    }
    // MemoryMonitor 须先于 RuntimeDiagnostics 初始化，确保其 visibilitychange 监听器先注册：
    // 页面隐藏时 MemoryMonitor 先完成 Unload 采样，RuntimeDiagnostics 后统一 flush(beacon)。
    initMemoryMonitor();
    initRuntimeDiagnostics();
    loadPerformanceMonitor();
    GTM.init();
    FBQ.init();

    initABTest();
  }
}

export const appLifecycle = new AppLifecycle();
